<template>
  <div class="cmp-tab mb-4 mb-md-0">
    <div ref="myTab" class="cmp-tab-wrap pt-md-12 pc">
      <div class="item g-pointer" :class="{'active': activeTab===item.val}" v-for="(item, index) in tabList" :key="index" @click="clickTab(item, index)">
        <!-- <i class="icon"></i> -->
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      activeVal: {
        type: String,
        default: '1'
      }
    },
    watch: {
      tabs(newVal) {
        this.tabList = newVal
      },
      activeVal: {
        handler(newVal) {
          this.activeTab = newVal
          this.$nextTick(() => {
            this.initTabSrcoll()
          })
        },
        immediate: true
      }
    },
    data() {
      return {
        activeTab: this.activeVal || '1',
        tabList: this.tabs,
        currentIndex: 0
        // tabList: [
        //   {
        //     name: '展厅实景',
        //     val: '1',
        //   },
        //   {
        //     name: '展品详情',
        //     val: '2'
        //   }
        // ],
      }
    },
    methods: {
      clickTab(item, index) {
        if(this.activeTab !== item.val) {
          this.currentIndex = index
          this.activeTab = item.val
          // this.$emit('eventTabClick', item.val, index)
          this.$emit('eventTabClick', item.val, item, index)
          this.getTabItemWidth()
        }
      },
      // 获取左移动位置
      getTabItemWidth() {
        if(!this.$refs.myTab) {
          return
        }
        let arr = this.$refs.myTab.getElementsByClassName('item')
        let lineLeft = 0  // 前面的宽度总和
        let currentWidth = 0 // 当前元素宽度
        for (let i = 0; i < arr.length; i++) {
          if (i < this.currentIndex) {
            lineLeft += arr[i].clientWidth
          } else if (i == this.currentIndex) {
            currentWidth = arr[i].clientWidth
          } else {
            break
          }
        }

        lineLeft = lineLeft + currentWidth / 2
        let containerWidth = this.$refs.myTab.clientWidth
        let scrollLeft = lineLeft - containerWidth / 2
        // console.log(lineLeft)
        // console.log(containerWidth)
        // console.log(99, scrollLeft)
        this.$refs.myTab.scrollLeft = scrollLeft
      },
      initTabSrcoll() {
        this.currentIndex = this.tabList.findIndex(item => item.val === this.activeTab)
        this.getTabItemWidth()
      }
    }
  }
</script>

<style lang="scss" scoped>
// .cmp-tab {
//   padding-right: 30px;
// }
.cmp-tab-wrap {
  // width: $minWidth;
  padding-left: 36px;
  margin: 0 auto;
  display: flex;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  // overflow-scrolling: touch;
  .item {
    position: relative;
    margin-right: 40px;
    font-size: 38px;
    padding-bottom: 16px;
    // line-height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #fff;
    border-bottom: solid 8px transparent;
    flex-shrink: 0; 
    // .icon {
    //   margin-right: 10px;
    //   width: 16px;
    //   height: 22px;
    //   background: url(~@images/g-title-icon-gray.svg) no-repeat center center;
    //   background-size: 100% 100%;
    // }
    &.active {
      // font-weight: bold;
      // border-bottom: solid 8px #fff;
      // .icon {
      //   background: url(~@images/g-title-icon.svg) no-repeat center center;
      //   background-size: 100% 100%;
      // }
    }
    // 解决右边距失效问题
    &:last-child {
      margin-right: 0;
      position: relative;
    }
    &:last-child::after {
      content: '';
      position: absolute;
      right: -36px;
      top: 0;
      display: block;
      width: 36px;
      height: 2px;
    }

    &.active::before {
      content: '';
      width: 100%;
      height: 8px;
      background: #fff;
      position: absolute;
      left: 0;
      bottom: 0;
      border-radius: 3px;
    }
  }

  // &::-webkit-scrollbar-track-piece {
  //   background: transparent;
  // }

  // &::-webkit-scrollbar {
  //   width: 2px;
  //   height: 2px;
  // }

  // &::-webkit-scrollbar-thumb {
  //   background: transparent;
  //   border-radius: 5px;
  // }
  &::-webkit-scrollbar{
    display: none;
    // width:0;
  } 

  // /deep/ ::-webkit-scrollbar {
  //   width: 0.01rem;
  //   opacity: 0;
  //   display: none;
  // }
  // /*定义滚动条轨道 内阴影+圆角*/
  // /deep/ ::-webkit-scrollbar-track {
  //   background-color: #fff;
  //   opacity: 0;
  // }
  // /*定义滑块 内阴影+圆角*/
  // /deep/ ::-webkit-scrollbar-thumb {
  //   width: 0.01rem;
  //   border-radius: 0.01rem;
  //   opacity: 0;
  // }
}
</style>